import React, { useEffect } from 'react';
import { ArrowLeft, Sparkles } from 'lucide-react';
import { useNavigate, useParams } from 'react-router-dom';
import PageWrapper from '../components/UI/PageWrapper';

const FEATURE_NAMES: Record<string, string> = {
  publishing: 'Publishing',
  'file-cabinet': 'File Cabinet',
  'beat-shop': 'Beat Shop',
  'box-office': 'Box Office',
  'merch-stand': 'Merch Stand',
};

const ComingSoonPage: React.FC = () => {
  const navigate = useNavigate();
  const { feature = '' } = useParams<{ feature: string }>();
  const featureName = FEATURE_NAMES[feature] || 'This feature';
  const statusLabel = feature === 'beat-shop' ? 'In development' : 'Coming soon';

  useEffect(() => {
    document.title = `${featureName} — ${statusLabel} | Nova`;
  }, [featureName, statusLabel]);

  return (
    <PageWrapper className="flex min-h-[calc(100vh-5rem)] items-center justify-center px-4 py-10">
      <section className="w-full max-w-xl rounded-2xl border border-gray-200 bg-white px-6 py-12 text-center shadow-sm sm:px-10">
        <div className="mx-auto mb-6 flex h-14 w-14 items-center justify-center rounded-full bg-blue-50 text-blue-600">
          <Sparkles size={26} aria-hidden="true" />
        </div>
        <p className="mb-2 text-[0.68rem] font-semibold uppercase tracking-[0.18em] text-blue-600">
          {statusLabel}
        </p>
        <h1 className="font-family-messina-modern text-3xl font-semibold text-gray-900">
          {featureName}
        </h1>
        <p className="mx-auto mt-4 max-w-md text-sm leading-6 text-gray-500">
          We’re building this experience for Nova. It will become available here in a future update.
        </p>
        <button
          type="button"
          onClick={() => navigate(-1)}
          className="mx-auto mt-8 flex items-center justify-center gap-2 rounded-full bg-black px-5 py-2.5 text-sm font-medium text-white transition hover:bg-gray-800 focus:outline-none focus:ring-2 focus:ring-black focus:ring-offset-2"
        >
          <ArrowLeft size={16} aria-hidden="true" />
          Go back
        </button>
      </section>
    </PageWrapper>
  );
};

export default ComingSoonPage;
